var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.url&&_vm.token)?_c('iframe',{staticClass:"pageIframe",class:{'fullscreen':_vm.fullscreen},attrs:{"allowfullscreen":"","allow":"fullscreen","src":_vm.url,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }